import { Reducer } from 'redux';
import { IAction } from '../types';
import { localKeyInfo } from '../config';
import LocalStore from '@/utils/store';

export interface MsgInfoState {
  msgItem: any;
}

const LOCALKEY = localKeyInfo.msgItem;
const localVoiceInfo = LocalStore.getValue<MsgInfoState>(LOCALKEY) || {};

export const msgInfo: MsgInfoState = {
  msgItem: undefined,
  ...localVoiceInfo
};

export const setMsgInfo: (payload: MsgInfoState) => IAction<MsgInfoState> = (payload: MsgInfoState) => ({
  type: 'setMsgInfo',
  payload
});

const msgInfoReducer: Reducer<MsgInfoState, IAction<any>> = (state = msgInfo, action: IAction<any>) => {
  const { type, payload } = action;
  switch (type) {
    case 'setMsgInfo':
      LocalStore.setValue(LOCALKEY, payload);
      return {
        ...payload
      };
    default:
      return state;
  }
};

export default msgInfoReducer;
